import MarketplaceItemShippingTab from './MarketplaceItemShippingTab'

export default MarketplaceItemShippingTab
